import { useEffect, useState } from "react";
import ApiClient from "../../ApiClient";

const { getTransactionSessionInfo, getMerchantName } = ApiClient();

const UseHostedCheckoutV2 = (token, sessionId) => {
    const [isFetchingSessionInfo, setIsFetchingSessionInfo] = useState(true);
    const [sessionInfo, setSessionInfo] = useState({});
    const [merchantName, setMerchantName] = useState(null);

    useEffect(() => {
        if (!token) return;

        const onSuccess = (response) => {
            setSessionInfo(response);
        }

        const onFail = (response) => {
            console.log(response);
        }

        const getInfo = async () =>{
            try {
                setIsFetchingSessionInfo(true);
                await getTransactionSessionInfo(token, sessionId, onSuccess, onFail);
            } catch (error) {
                console.log(error);
            } finally {
                setIsFetchingSessionInfo(false);
            }
        }

        getInfo();
    }, [token, sessionId]);

    useEffect(() => {
         if (!token) return;

        const onSuccess = (response) => {
            setMerchantName(response.response.name);
        }

        const onFail = (response) => {
            console.log(response);
        }

        const getInfo = async () =>{
            try {
                await getMerchantName(token, onSuccess, onFail);
            } catch (error) {
                console.log(error);
            } 
        }

        getInfo();
    }, [token]);

    return {
        isFetchingSessionInfo,
        sessionInfo,
        merchantName,
    };
}

export default UseHostedCheckoutV2;
